const toSeconds = (value) => {
  if (!value || typeof value !== 'string') return null;
  const [minutes, seconds] = value.split(':').map(Number);
  if (!Number.isFinite(minutes) || !Number.isFinite(seconds)) return null;
  return (minutes * 60) + seconds;
};

export const getTimerColors = (
  time,
  agendaEvent = {},
  fallbackColors = { background: 'black', foreground: '#ffffff' }
) => {
  const elapsed = Number(time);
  const green = toSeconds(agendaEvent.green);
  const amber = toSeconds(agendaEvent.amber);
  const red = toSeconds(agendaEvent.red);

  if (red !== null && elapsed > red + 30) {
    return { background: 'black', foreground: '#ffffff' };
  }
  if (red !== null && elapsed >= red) {
    return { background: '#dc3545', foreground: '#ffffff' };
  }
  if (amber !== null && elapsed >= amber) {
    return { background: '#ffc107', foreground: '#000000' };
  }
  if (green !== null && elapsed >= green) {
    return { background: '#146c43', foreground: '#ffffff' };
  }
  return fallbackColors;
};
